module.exports = __webpack_public_path__ + "39a3533b860a044be57c93877ff27c66.pdf";